import * as React from 'react';
import { useSelector } from 'react-redux';

import { EmptyListingStub } from '../../components/EmptyListingStub';
import { getCurrentTab } from '../../selectors/tabs';
import { setAgenciesTab, setRealtorsTab } from '../../actions/tabs';
import { ETabs } from '../../types/redux/tabs';
import { Pseudolink } from '../../components/packages/Pseudolink';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { trackGoToRealtor, trackShowEmpty } from './tracking';
import { HELP_URL } from './constants';
import { useAppDispatch } from '../../hooks/useAppDispatch/useAppDispatch';

const TEXTS: { [K in ETabs]: string } = {
  [ETabs.Agencies]: 'поиск риелторов',
  [ETabs.Realtors]: 'поиск агентств',
};

export const EmptyListingStubContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const activeTab = useSelector(getCurrentTab);
  const deviceType = useDeviceType();

  React.useEffect(() => {
    trackShowEmpty();
  }, []);

  const handleRealtorClick = React.useCallback(() => {
    trackGoToRealtor(deviceType);
  }, [deviceType]);

  const changeTabsAction = React.useMemo(() => {
    const handleChangeTab = () => dispatch((activeTab === ETabs.Realtors ? setAgenciesTab : setRealtorsTab)());

    return <Pseudolink onClick={handleChangeTab}>{TEXTS[activeTab]}</Pseudolink>;
  }, [activeTab, dispatch]);

  return <EmptyListingStub changeTabsAction={changeTabsAction} url={HELP_URL} onClick={handleRealtorClick} />;
};

EmptyListingStubContainer.displayName = 'EmptyListingStubContainer';
